
import { storeToRefs } from 'pinia';
import { ref } from 'vue';
import { useAuthStore } from '../../stores/auth';
import { showVuePopup } from '../../utils/showVuePopup';
import Favorite from '../../popup/Favorite.vue';
import Recently from '../../popup/Recently.vue';

export default {
	name: 'GameNavbar',
	setup() {
		const auth = useAuthStore();
		auth.hydrate();
		const { profile } = storeToRefs(auth);

		const menus = ref([
			// { name: 'Demo', href: '/demo', image: 'https://168snc.sgp1.cdn.digitaloceanspaces.com/theme/tab-demo.webp', show: true },
			{ name: 'Favorite', handle: () => showVuePopup(Favorite), image: 'https://snc168.sgp1.cdn.digitaloceanspaces.com/theme/tab-favorite.webp', show: auth.isLoggedIn },
			{ name: 'Recently', handle: () => showVuePopup(Recently), image: 'https://168snc.sgp1.cdn.digitaloceanspaces.com/theme/tab-recently.webp', show: auth.isLoggedIn },
			{ name: 'Recommended', href: '/recommended', image: 'https://snc168.sgp1.cdn.digitaloceanspaces.com/theme/tab-hot.gif', show: true },
			{ name: 'Slot', href: '/slot', image: 'https://snc168.sgp1.cdn.digitaloceanspaces.com/theme/tab-slot.webp', show: true },
			{ name: 'Casino', href: '/casino', image: 'https://snc168.sgp1.cdn.digitaloceanspaces.com/theme/tab-casino.webp', show: true },
			{ name: 'Poker', href: '/poker', image: 'https://snc168.sgp1.cdn.digitaloceanspaces.com/theme/tab-poker.webp', show: true },
			{ name: 'Card', href: '/card', image: 'https://snc168.sgp1.cdn.digitaloceanspaces.com/theme/tab-card.webp', show: true },
			{ name: 'Fish Hunter', href: '/fishhunter', image: 'https://snc168.sgp1.cdn.digitaloceanspaces.com/theme/tab-fishhunter.webp', show: true },
			{ name: 'Lotto', href: '/lotto', image: 'https://snc168.sgp1.cdn.digitaloceanspaces.com/theme/tab-lotto.webp', show: true },
			{ name: 'Sport', href: '/sport', image: 'https://snc168.sgp1.cdn.digitaloceanspaces.com/theme/tab-sport.webp', show: true },
			{ name: 'Keno', href: '/keno', image: 'https://snc168.sgp1.cdn.digitaloceanspaces.com/theme/tab-keno.webp', show: true },
			{ name: 'Trade', href: '/trade', image: 'https://snc168.sgp1.cdn.digitaloceanspaces.com/theme/tab-trade.webp', show: true },
			{ name: 'Cockfighting', href: '/cockfighting', image: 'https://snc168.sgp1.cdn.digitaloceanspaces.com/theme/tab-cockfighting.webp', show: true },
			{ name: 'E-Sport', href: '/esport', image: 'https://snc168.sgp1.cdn.digitaloceanspaces.com/theme/tab-esport.webp', show: true },
		]);

		return {
			profile,
			menus,
		};
	},
}
